import CarModel from "./carModel";
import "./style.scss";

const TechIntroSection_1 = () => {
	return (
		<section className="tech-intro-section_1">
			<div className="tech-intro-section_1__content">
				<div className="tech-intro-section_1__title-wrapper">
					<h2 className="tech-intro-section_1__title title">
						선명한 VIEW
						<br />
						강력한 GUARD
					</h2>
					<p className="tech-intro-section_1__sub-title sub-title">
						뷰아드는 선명한 VIEW와 강력한 GUARD입니다.
					</p>
				</div>
				<CarModel />
			</div>
		</section>
	);
};

export default TechIntroSection_1;
